var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../../ts/components/LazyLoader';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-filter').on('click', (event, button) => {
                event.preventDefault();
                button.parents('.filter').find('.btn-filter').removeClass('is-active');
                button.addClass('is-active');
                $('.events').empty().addClass('is-loading').html('<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>');
                this.filter();
            });
            this.success();
        });
    }
    filter() {
        return __awaiter(this, void 0, void 0, function* () {
            const eventsHTML = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    'action': 'get_events',
                    'day': $('.filter-day .is-active').data('value'),
                    'category': $('.filter-category .is-active').data('value'),
                    'place': $('.filter-place .is-active').data('value')
                },
                dataType: 'html'
            });
            $('.events').empty().removeClass('is-loading').append(eventsHTML);
            // Update filters state
            $('.btn-filter:not([data-value="0"])').addClass('disabled');
            $('.event').each((event) => {
                const days = event.data('days');
                const category = event.data('category');
                const place = event.data('place');
                if (days == null || category == null || place == null)
                    return;
                days.split(',').forEach((day) => {
                    $('.filter-day .btn-filter[data-value="' + day + '"]').removeClass('disabled');
                });
                $('.filter-category .btn-filter[data-value="' + category + '"]').removeClass('disabled');
                $('.filter-place .btn-filter[data-value="' + place + '"]').removeClass('disabled');
            });
            LazyLoader.refreshImageList();
            LazyLoader.checkImageVisibility();
        });
    }
}
